import { useState } from 'react';

export default function ChatWidget() {
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState([
    { id: 1, text: '¡Hola! Bienvenido a Hits Collections Station. ¿En qué puedo ayudarte?', sender: 'bot' }
  ]);
  const [inputMessage, setInputMessage] = useState('');

  const handleSendMessage = (e: React.FormEvent) => {
    e.preventDefault();
    if (inputMessage.trim()) {
      setMessages([...messages, { id: messages.length + 1, text: inputMessage, sender: 'user' }]);
      setInputMessage('');
      
      setTimeout(() => {
        setMessages(prev => [...prev, { 
          id: prev.length + 1, 
          text: 'Gracias por tu mensaje. Un operador te responderá pronto.', 
          sender: 'bot' 
        }]);
      }, 1000);
    }
  };

  return (
    <>
      {/* Chat Button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="fixed bottom-4 right-4 sm:bottom-6 sm:right-6 z-50 w-12 h-12 sm:w-14 sm:h-14 bg-[#d4af37] rounded-full flex items-center justify-center shadow-lg hover:shadow-xl hover:shadow-[#d4af37]/50 transition-all duration-300 cursor-pointer group"
      >
        <i className={`${isOpen ? 'ri-close-line' : 'ri-chat-3-line'} text-xl sm:text-2xl text-black group-hover:scale-110 transition-transform`}></i>
      </button>

      {/* Chat Window */}
      {isOpen && (
        <div className="fixed bottom-20 right-4 sm:bottom-24 sm:right-6 z-50 w-[calc(100vw-2rem)] sm:w-96 bg-[#1a1a1a] rounded-2xl shadow-2xl border border-[#d4af37]/30 overflow-hidden">
          {/* Header */}
          <div className="bg-[#d4af37] p-3 sm:p-4 flex items-center gap-3">
            <div className="w-8 h-8 sm:w-10 sm:h-10 bg-black rounded-full flex items-center justify-center">
              <i className="ri-customer-service-line text-[#d4af37] text-base sm:text-lg"></i>
            </div>
            <div className="flex-1">
              <h3 className="text-black font-bold text-sm sm:text-base" style={{ fontFamily: 'Playfair Display, serif' }}>
                Chat en Vivo
              </h3>
              <p className="text-black/70 text-xs">Estamos aquí para ayudarte</p>
            </div>
          </div>

          {/* Messages */}
          <div className="h-64 sm:h-80 overflow-y-auto p-3 sm:p-4 space-y-3 sm:space-y-4 scrollbar-hide">
            {messages.map((message) => (
              <div
                key={message.id}
                className={`flex ${message.sender === 'user' ? 'justify-end' : 'justify-start'}`}
              >
                <div
                  className={`max-w-[80%] sm:max-w-[75%] px-3 sm:px-4 py-2 sm:py-3 rounded-2xl text-xs sm:text-sm ${
                    message.sender === 'user'
                      ? 'bg-[#d4af37] text-black'
                      : 'bg-white/10 text-white'
                  }`}
                >
                  {message.text}
                </div>
              </div>
            ))}
          </div>

          {/* Input */}
          <form onSubmit={handleSendMessage} className="p-3 sm:p-4 border-t border-white/10">
            <div className="flex gap-2">
              <input
                type="text"
                value={inputMessage}
                onChange={(e) => setInputMessage(e.target.value)}
                placeholder="Escribe tu mensaje..."
                className="flex-1 bg-white/10 text-white placeholder-white/50 px-3 sm:px-4 py-2 sm:py-3 rounded-full focus:outline-none focus:ring-2 focus:ring-[#d4af37] text-xs sm:text-sm"
              />
              <button
                type="submit"
                className="w-9 h-9 sm:w-10 sm:h-10 bg-[#d4af37] rounded-full flex items-center justify-center hover:shadow-lg hover:shadow-[#d4af37]/50 transition-all duration-300 cursor-pointer flex-shrink-0"
              >
                <i className="ri-send-plane-fill text-black text-base sm:text-lg"></i>
              </button>
            </div>
          </form>
        </div>
      )}
    </>
  );
}
